interface InfoItem {
  label: string;
  value: string | JSX.Element;
  note?: string;
}

const shopInfoItems: InfoItem[] = [
  { label: '店舗名', value: 'baba Kaba' },
  {
    label: '住所',
    value: '〒198-0001 東京都青梅市成木1丁目1番',
    note: '飯能駅より車で約11分',
  },
  {
    label: '電話番号',
    value: (
      <a
        href="tel:08097798744"
        className="font-bold hover:opacity-80 transition-opacity cursor-pointer"
        style={{ color: '#f5a623' }}
      >
        080-9779-8744
      </a>
    ),
  },
  { label: '営業時間（平日）', value: '9:00〜18:00' },
  { label: '営業時間（土日祝）', value: '9:00〜18:00' },
  { label: '定休日', value: '不定期（基本年中無休）' },
];

export default function ShopInfoSection() {
  return (
    <section
      id="shop-info"
      className="py-20 md:py-28"
      style={{ backgroundColor: '#1a1a1a', borderTop: '1px solid rgba(255,255,255,0.06)' }}
      aria-label="店舗情報・アクセス"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Section header */}
        <div className="mb-12">
          <p
            className="text-xs font-bold tracking-widest uppercase mb-3"
            style={{ color: '#f5a623', fontFamily: '"Oswald", sans-serif', letterSpacing: '4px' }}
          >
            Shop Info &amp; Access
          </p>
          <h2
            className="text-3xl md:text-4xl font-black text-white"
            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
          >
            店舗情報・<span style={{ color: '#f5a623' }}>アクセス</span>
          </h2>
          <div className="w-12 h-1 mt-4" style={{ backgroundColor: '#f5a623' }} />
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left: Info list */}
          <div className="w-full lg:w-[40%]">
            <dl>
              {shopInfoItems.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row sm:items-start py-5"
                  style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}
                >
                  <dt
                    className="w-full sm:w-40 flex-shrink-0 text-sm mb-1 sm:mb-0"
                    style={{ color: 'rgba(255,255,255,0.5)', fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    {item.label}
                  </dt>
                  <dd className="flex-1">
                    <span
                      className="text-sm md:text-base font-medium text-white"
                      style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                    >
                      {item.value}
                    </span>
                    {item.note && (
                      <p
                        className="text-xs mt-1 italic"
                        style={{ color: 'rgba(255,255,255,0.45)', fontFamily: '"Noto Sans JP", sans-serif' }}
                      >
                        {item.note}
                      </p>
                    )}
                  </dd>
                </div>
              ))}
            </dl>

            {/* Phone CTA */}
            <a
              href="tel:08097798744"
              className="flex items-center justify-center gap-3 mt-8 py-4 rounded font-bold text-base whitespace-nowrap transition-all hover:opacity-90 active:scale-95"
              style={{
                backgroundColor: '#f5a623',
                color: '#1a1a1a',
                fontFamily: '"Noto Sans JP", sans-serif',
              }}
            >
              <i className="ri-phone-fill text-lg"></i>
              080-9779-8744 に電話する
            </a>
          </div>

          {/* Right: Google Map */}
          <div className="flex-1 relative min-h-[300px] md:min-h-[420px]">
            {/* Map header bar */}
            <div
              className="flex items-center gap-2 px-4 py-3"
              style={{ backgroundColor: 'rgba(245,166,35,0.1)', border: '1px solid rgba(245,166,35,0.2)', borderBottom: 'none' }}
            >
              <i className="ri-map-pin-fill" style={{ color: '#f5a623' }}></i>
              <span
                className="text-sm font-medium text-white"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                ACCESS — 東京都青梅市成木1丁目1番
              </span>
            </div>
            <iframe
              title="Kaba baba 店舗地図"
              src="https://maps.google.com/maps?q=%E6%9D%B1%E4%BA%AC%E9%83%BD%E9%9D%92%E6%A2%85%E5%B8%82%E6%88%90%E6%9C%A81%E4%B8%81%E7%9B%AE1%E7%95%AA&output=embed&hl=ja&z=15"
              width="100%"
              height="400"
              style={{ border: '1px solid rgba(245,166,35,0.2)', display: 'block' }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}